
export class StripeCustomerToken {
  accountID: number;
  sourceToken: string;

  constructor(values: object = {}) {
    Object.assign(this, values);
  }
}
